import { ReactFlowProvider } from "@xyflow/react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router.js";

export default function App() {
  return (
    <ReactFlowProvider>
      <RouterProvider router={router} />
    </ReactFlowProvider>
  );
}
